var React = require('react');

function DownloadInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M11 2h2v12.367L17.598 10 19 11.342 12 18l-7-6.658L6.402 10 11 14.367V2Zm11 20v-2H2v2h20Z","clipRule":"evenodd"}));
}

DownloadInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","role":"img","aria-label":""};

module.exports = DownloadInline;

DownloadInline.default = DownloadInline;
